import { render, staticRenderFns } from "./RbuExtraItemRow.vue?vue&type=template&id=5b7cc360"
import script from "./RbuExtraItemRow.vue?vue&type=script&lang=js"
export * from "./RbuExtraItemRow.vue?vue&type=script&lang=js"
import style0 from "./RbuExtraItemRow.vue?vue&type=style&index=0&id=5b7cc360&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports